import {makeStyles} from "@material-ui/core/styles";

export const  useStyles = makeStyles((theme) => ({
    tableBox:{
        borderRadius: '8px 8px 0 0',
        boxShadow: 'none',
        background:'#fff',
        '&::-webkit-scrollbar': {
            width: '10px',
            height: '10px'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#6f6f6f',
            borderRadius: '10px',
            backgroundClip: 'padding-box',
            border: '3px solid transparent',
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
            marginTop: 5,
        },
    },
    table: {
        minWidth: 930,
        overflowX:'auto',
    },
    tableHeadStyle:{
        '& th':{
            height: 50,
            padding: '0 10px',
            fontSize: '1rem',
            fontWeight: 700,
            color: '#10121C',
            borderBottom: '1px solid #BCBCBC'
        }
    },
    tableBodyStyle:{
        '& th, td':{
            padding: '13px 10px',
            fontSize: '1rem',
            fontWeight: 400,
            color: '#10121C',
            borderBottom: '1px solid #BCBCBC'
        },
        '& th':{
            fontWeight: 700,
        },
    },
    tableButton:{
        '&.MuiButton-root': {
            width: 80,
            height:30,
            borderRadius: 4,
            background: '#5579F0',
            padding: 0,
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 700,
        },
        '&:hover':{
            background:'#5579F0'
        }
    },
    sortButton:{
        cursor:'pointer',
        display:'flex',
        alignItems: 'center',
        '& p':{
            fontSize: '1rem',
            fontWeight: 700,
            color: '#10121C',
            marginRight: 4
        }
    },
    paginationBox:{
        '& .MuiToolbar-root':{
            position: 'relative',
        },
        '& .MuiInputBase-root':{
            marginLeft: 0,
            marginRight: 20
        },
        '& .MuiSelect-select':{
            fontSize: '0.75rem',
            color:'#323232',
            paddingRight: 17,
            '&:focus':{
                background:'transparent'
            }
        },
        '& .MuiTablePagination-caption':{
            fontSize: '0.75rem',
            color: '#10121c',
            fontWeight: 400
        },
        '& .MuiTablePagination-selectLabel':{
            fontSize: '0.75rem',
            color:'#323232',
        },
        '& .MuiTablePagination-selectRoot':{
            '& svg':{
                marginTop: 3
            }
        },
        '& button':{
            padding:0,
            '&:hover':{
                background:'transparent'
            },
        }
    },
    displayRow:{
        '& span':{
            fontWeight: '700 !important'
        }
    },
    selectPopover:{
        '& .MuiPaper-root':{
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
            border: '1px solid #bbb',
            boxSizing:'border-box',
            '& *': {
                fontFamily: 'Pretendard !important',
            },
        },
        '& .MuiMenuItem-root':{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '0.875rem',
            color:'#323232',
            padding: '0 12px',
            boxSizing: 'border-box',
            height: 28,
            '&:hover':{
                background: '#eee'
            },
            '&.Mui-selected':{
                background: '#eee'
            },
            '&.Mui-disabled': {
                opacity: 1,
                '& svg':{
                    pointerEvents: 'auto'
                }
            },
        }
    },
    activeStepIcon: {
        width: '100%',
        padding: 0,
        marginTop: 5,
        '& .MuiStepIcon-active': {
            color: '#5579f0',
        },
        '& .MuiStepIcon-completed': {
            border: '1px solid #5579f0',
            borderRadius: '100%',
            color: '#fff'
        },
        '& .MuiStepLabel-label': {
            wordBreak: 'break-word',
        },
    },
}));

